import VueRouter from "vue-router";

// import index from "@/views/pedigree/index";
import pedigree from "@/views/pedigree/pedigree";
import pedigreeM from "./pedigreeM";

const propHandler = (route)=>Object.assign({},route.query, route.params);
const routes = [
    // { path: '/pedigree/index.html',component: index, props:propHandler},
    { path: '/pedigree/:type',component: pedigree, props:propHandler},
    { path: '/pedigreeM/:type',component: pedigreeM, props:propHandler},
];
const router = new VueRouter({
    mode: "history",
    routes
});

export default router;
